module.exports = __webpack_public_path__ + "img/Rolgordijn.214ff6a9.png";